import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import SubtleBadge from '@/components/common/SubtleBadge';
import { formatSourceGapStatus } from '../../utils/source-insights';
import type { SourceGapType } from '../../types';

const GAP_META: Record<SourceGapType, { bg: string; icon: IconProp }> = {
  competitor_only: { bg: 'warning', icon: 'exclamation-triangle' },
  you_underrepresented: { bg: 'danger', icon: 'arrow-down' },
  shared: { bg: 'secondary', icon: 'share-alt' },
};

export function SourceGapStatusBadge({ gapType }: { gapType: SourceGapType }) {
  const meta = GAP_META[gapType];
  return (
    <div
      className="w-100 d-flex align-items-center justify-content-center"
      style={{ height: '100%' }}
    >
      <SubtleBadge
        bg={meta.bg}
        pill
        className="w-100 d-flex justify-content-center align-items-center fs--2 fw-normal"
      >
        <FontAwesomeIcon icon={meta.icon} transform="shrink-2" className="mx-1" />
        {formatSourceGapStatus(gapType)}
      </SubtleBadge>
    </div>
  );
}
